import type { IProfilePictureFile } from 'types/user';
import { DOMAINS, getAssetURL, replaceUrlHostname } from 'utils/assets';
import { IS_DEVEL } from 'utils/environment';
import { prependUrlProtocol } from 'utils/url/prepend-url-protocol';

export function getUserAvatarLink(profilePictureFile?: Partial<IProfilePictureFile> | null) {
	const filepath = profilePictureFile?.filepath?.replace(/^\/+/, '');

	if (!filepath) {
		return '';
	}

	const hosting = profilePictureFile?.hosting?.trim();

	if (!hosting) {
		const fallbackDomain = IS_DEVEL ? DOMAINS.DEV_IMAGE : DOMAINS.PROD_IMAGE;
		return prependUrlProtocol(`${fallbackDomain}/${filepath}`, 'https');
	}

	return replaceUrlHostname(getAssetURL({ filepath, hosting }, true));
}
